/**
 * Count keys and exclude any null or undefined
 */
export function countKeys(value: Record<string, unknown> | null | undefined) {
  if (!value) {
    return 0
  }

  const totalKeys = Object.keys(value)

  return totalKeys.filter(key => value[key] != null).length
}
